import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const ModelHubRoutes: RouteBundle = {
  domain: 'model-hub',
  routes: [{urlPattern: 'model-hub', handler: EditorRoutes.modelHub.bind(EditorRoutes), legacy: true}],
};
